module.exports = __webpack_public_path__ + "static/media/content.5bed895b.jpg";